import createIcon from "../createIcon";
export var GmailConfig = {
  displayName: "Gmail",
  attrs: {
    fill: "currentColor"
  },
  css: {
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    maxHeight: "100%",
    maxWidth: "100%",
    margin: "auto"
  },
  width: 24,
  height: 24,
  color: "#D14836",
  titleKey: "Gmail-title",
  viewBox: "0 0 24 24",
  labelledby: "icon-title-Gmail",
  body: [{
    type: "path",
    props: {
      d: "M24 4.5v15c0 .85-.65 1.5-1.5 1.5H21V7.387l-9 6.463-9-6.463V21H1.5C.649 21 0 20.35 0 19.5v-15c0-.425.162-.8.431-1.068A1.485 1.485 0 0 1 1.5 3H2l10 7.25L22 3h.5c.425 0 .8.162 1.069.432.27.268.431.643.431 1.068z",
      key: "k0"
    }
  }]
};
export default createIcon(GmailConfig);